import React, { useState } from 'react';
import TextField from 'material-ui/TextField'
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import { withStyles } from 'material-ui/styles'
import styles from './styles'

class InputPasswordField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  toggleVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  render() {
    const {
      classes, id, name, label, autoComplete, value, onChange, error, helperText, disabled, margin
    } = this.props;

    const {
      showPassword
    } = this.state;
    
    return (
      <div className={classes.wrapper}>
        <TextField
          id={id}
          name={name && name.length ? name : id}
          margin={margin && margin.length ? margin : "none"}
          error={error}
          required
          type={showPassword ? 'text' : 'password'}
          label={label}
          variant="outlined"
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          className={classes.textField}
          helperText={helperText}
          disabled={disabled}
          fullWidth
          InputProps={{
            classes: {
              input: classes.input,
            },
          }}
        />
        <div className={classes.iconWrapper}>
          <IconButton size="small" onClick={this.toggleVisibility}>
            <Icon>{showPassword ? 'visibility_off' : 'visibility'}</Icon>
          </IconButton>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(InputPasswordField);